import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Navbar from './components/layout/Navbar'
import Footer from './components/layout/Footer'
import Upload from './pages/Upload'

function App() {
  const location = useLocation()
  const { t } = useTranslation()
  const hideFooter = ['/upload', '/style-select', '/result'].some((path) =>
    location.pathname.startsWith(path)
  )

  useEffect(() => {
    document.title = `Al Experience Center - ${t('nav.studioLabel')}`
  }, [t])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' })
  }, [location.pathname])

  return (
    <div className="min-h-screen flex flex-col bg-surface text-on-surface antialiased">
      <Navbar />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Navigate to="/upload" replace />} />
          <Route path="/upload" element={<Upload />} />
          <Route path="/style-select" element={<Navigate to="/upload" replace />} />
          <Route path="/result" element={<Navigate to="/upload" replace />} />
          <Route path="*" element={<Navigate to="/upload" replace />} />
        </Routes>
      </div>
      {!hideFooter && <Footer />}
    </div>
  )
}

export default App
